import Icon from "@ant-design/icons";

const SVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="20"
    viewBox="0 0 18 20"
  >
    <g id="user_3_" data-name="user (3)" transform="translate(-3 -2)">
      <path
        id="Path_1076"
        data-name="Path 1076"
        d="M20,21V19a4,4,0,0,0-4-4H8a4,4,0,0,0-4,4v2"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <circle
        id="Ellipse_64"
        data-name="Ellipse 64"
        cx="4"
        cy="4"
        r="4"
        transform="translate(8 3)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </g>
  </svg>
);

const AntdIcon = (props) => <Icon component={SVG} {...props} />;

export default AntdIcon;
